import {createSlice} from '@reduxjs/toolkit'
import {KhipuModel} from '../../models'

export const EmptyKhipuState: KhipuModel = {
  searchValues: {},
  searchValuesDetail: {},
  applicationId: 'Panel',
}

export const khipuSlice = createSlice({
  name: 'khipu',
  initialState: EmptyKhipuState,
  reducers: {
    setApplicationId: (state, action) => {
      return {...state, applicationId: action.payload}
    },
    setCurrentSearch: (state, action) => {
      return {
        ...state,
        searchValues: action.payload,
      }
    },
    setCurrentSearchDetail: (state, action) => {
      return {
        ...state,
        searchValuesDetail: action.payload,
      }
    },
    clearSearchDetail: (state) => {
      return {
        ...state,
        searchValuesDetail: {},
      }
    },
    clearSearch: (state) => {
      return {
        ...state,
        searchValues: {},
      }
    },
    resetKhipu: () => {
      return EmptyKhipuState
    },
  },
})

export const {
  setApplicationId,
  resetKhipu,
  setCurrentSearch,
  clearSearch,
  setCurrentSearchDetail,
  clearSearchDetail,
} = khipuSlice.actions

export default khipuSlice.reducer
